import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site-content");
      setContent(data || {});
    } catch (e) {
      // fail silently — fallbacks kick in
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const t = (key, fallback = "") => {
    const v = content[key];
    return v == null || v === "" ? fallback : v;
  };

  return (
    <ContentContext.Provider value={{ content, t, refresh, loaded }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}
